angular.module("dx.webapp.masterTools", [
	"digiexam.services",
	"dx.webapp.api",
	"dx.webapp.navigation",

	"ngPasteFrom",
]);

